import React, { useState, useRef } from "react";
import { Trash, X, XCircle, MinusCircle,Filter  } from "lucide-react";

export default function ImagePanel({images,onImagesChange,onImagesSelected, onTransitionChange, transitionDuration, onTransitionDurationChange,filters,onOpenFilter}) {
    //const [images, setImages] = useState([]); 
    const fileInputRef = useRef(null);

    const handleFiles = (files) => {
      const newFiles = Array.from(files).map((file) => ({
        file,
        url: URL.createObjectURL(file),
        selected: true, // default = checked
      }));

      // MERGE with previous uploads
      const updated = [...images, ...newFiles];
      onImagesChange(updated);

      // Send SELECTED ONLY to parent
      const selectedFiles = updated.filter((img) => img.selected).map((img) => img.file);
      onImagesSelected(selectedFiles);
      };

    const toggleSelected = (index) => {
      const updated = [...images];
      updated[index].selected = !updated[index].selected;

      onImagesChange(updated);

      const selectedFiles = updated.filter((img) => img.selected).map((img) => img.file);
      onImagesSelected(selectedFiles);
    };

    const deleteImage = (index) => {
      const updated = images.filter((_, i) => i !== index);

      onImagesChange(updated);

      const selectedFiles = updated
        .filter((img) => img.selected)
        .map((img) => img.file);

        onImagesSelected(selectedFiles);
      };


  return (
  <div
    className="
      p-4 flex flex-col gap-4
      text-gray-900 dark:text-gray-100
    "
  >
    {/* Title */}
    <h3 className="text-lg font-semibold">Images</h3>

    {/* ───────── Transition Dropdown ───────── */}
    <label className="flex flex-col gap-1">
      <span className="text-sm text-gray-600 dark:text-gray-400">
        Transition
      </span>

      <select
        className="
          p-2 rounded-md
          bg-white dark:bg-gray-800
          border border-gray-300 dark:border-gray-700
          text-gray-900 dark:text-gray-100
          focus:outline-none focus:ring-2 focus:ring-blue-500
        "
        onChange={(e) => onTransitionChange(e.target.value)}
      >
        <option value="fade">Fade</option>
        <option value="slide-left">Slide Left</option>
        <option value="slide-right">Slide Right</option>
        <option value="zoom-in">Zoom In</option>
        <option value="bounce">Bounce</option>
        <option value="flip">Flip</option>
        <option value="wipe">Wipe</option>
        <option value="blur">Blur</option>
        <option value="glitch">Glitch</option>
        <option value="parallax">Parallax</option>
        <option value="directional-fade">Directional Fade</option>
      </select>
    </label>

    {/* ───────── Transition Duration ───────── */}
    <label className="flex flex-col gap-1">
      <span className="text-sm text-gray-600 dark:text-gray-400">
        Transition Duration (seconds)
      </span>

      <input
        type="range"
        min={0.2}
        max={3}
        step={0.1}
        value={transitionDuration}
        className="w-full accent-blue-500"
        onChange={(e) =>
          onTransitionDurationChange(parseFloat(e.target.value))
        }
      />

      <span className="text-sm text-gray-700 dark:text-gray-300">
        {transitionDuration}s
      </span>
    </label>

    {/* ───────── Upload Box ───────── */}
    <div
      className="
        border border-dashed
        border-gray-300 dark:border-gray-700
        rounded-lg p-4 text-center cursor-pointer
        bg-gray-50 hover:bg-gray-100
        dark:bg-gray-800 dark:hover:bg-gray-700
        transition-colors
      "
      onClick={() => fileInputRef.current.click()}
    >
      <p className="text-gray-700 dark:text-gray-300">
        Click to upload images
      </p>
      <p className="text-sm text-gray-500">
        (PNG, JPG, JPEG)
      </p>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        multiple
        className="hidden"
        onChange={(e) => handleFiles(e.target.files)}
      />
    </div>

    {/* ───────── Preview Grid ───────── */}
    {images.length > 0 && (
      <div className="grid grid-cols-3 gap-2">
        {images.map((img, idx) => (
          <div
            key={idx}
            className={`
              relative rounded overflow-hidden group
              border
              ${img.selected
                ? "border-blue-500"
                : "border-gray-300 dark:border-gray-700"}
            `}
          >
            {/* Image */}
            <img
              src={img.url}
              className="w-full h-20 object-cover"
              alt=""
            />

            {/* Checkbox */}
            <input
              type="checkbox"
              checked={img.selected}
              onChange={() => toggleSelected(idx)}
              className="absolute top-1 left-1 h-4 w-4 z-10"
            />

            {/* Delete */}
            <button
              onClick={() => deleteImage(idx)}
              className="
                absolute top-1 right-1 z-10
                p-1 rounded
                bg-black/40 hover:bg-black/60
                text-white
                opacity-0 group-hover:opacity-100
                transition-opacity
              "
            >
              <Trash size={14} className="text-red-400 hover:text-red-500" />
            </button>

            {/* FX Badge */}
            {filters?.[idx] && filters[idx] !== "none" && (
              <span
                className="
                  absolute bottom-1 left-1
                  text-xs px-1 rounded
                  bg-blue-600 text-white
                "
              >
                FX
              </span>
            )}

            {/* Filter button */}
            <button
              onClick={() => onOpenFilter(idx)}
              title="Edit filter"
              className="
                absolute bottom-1 right-1 z-10
                p-1 rounded
                bg-black/50 hover:bg-black/70
                text-white
                opacity-0 group-hover:opacity-100
                transition-opacity
              "
            >
              <Filter size={14} />
            </button>
          </div>
        ))}
      </div>
    )}
  </div>
);

}
